"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTooltipOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing, typography = _a.typography;
    return ({
        tooltip: __assign(__assign({}, typography.caption), { padding: spacing(3), color: palette.text.primary, backgroundColor: palette.background.paper, filter: "drop-shadow(2px 2px 10px rgba(0, 0, 0, 0.3))" }),
        arrow: {
            color: palette.background.paper,
        },
    });
};
//# sourceMappingURL=MuiTooltip.js.map